export const getJobVehicle = (job) => {
  const { year, make, model } = job
  return `${year || "<Year>"} ${make || "<Make>"} ${model || "<Model>"}`;
}

export default { getJobVehicle };